export default "__VITE_ASSET__BW$HXHQm__"